<template>
    <v-select
        v-bind="$attrs"
        :items="langs"
        item-value="value"
        item-text="text"
        dense
        outlined
        v-on="$listeners"
    ></v-select>
</template>

<script>
export default {
    name: 'LangSelect',
    data() {
        return {
            langs: [
                { value: 'de', text: 'Deutsch' },
                // see #25292: Englisch wird erst später freigeschalten
                // { value: 'en', text: 'English' },
            ],
        };
    },
};
</script>
